<button [disabled]="disabled" (click)="importPlans()" onclick="this.blur();" class="sen-secondary-icon bg-white"
    mat-fab>
    <mat-icon class="mb-2">system_update_alt</mat-icon>
</button>